import { useEffect, useState } from 'react';
import PropType from 'prop-types';
import { useMachineFilter } from 'hooks/useMachineFilter';

export const OperatorFilter = ({ onChange }) => {
  const [MachineFilter, machineFilterState] = useMachineFilter();
  const [operatorFilterState, setOperatorFilterState] = useState({});

  useEffect(() => {
    if (
      machineFilterState.facility !== operatorFilterState.facility ||
      machineFilterState.object !== operatorFilterState.object ||
      machineFilterState.machineId !== operatorFilterState.machineId
    ) {
      const newState = { ...operatorFilterState, ...machineFilterState };
      setOperatorFilterState(newState);
      onChange(newState);
    }
  }, [machineFilterState, onChange, operatorFilterState]);

  return <MachineFilter />;
};

OperatorFilter.propTypes = {
  onChange: PropType.func.isRequired
};
